import type { IToggleBranchCreditParams } from 'core/model/interfaces/distributors/branches.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../../constants';
import type { IDistributorsState } from '../../types';

export const toggleBranchCredit = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/toggleBranchCredit`,
  async (params: IToggleBranchCreditParams, { rejectWithValue }) => {
    const { branch } = params;

    const { credit } = branch;

    try {
      await apiService.branches.toggleBranchCredit(params);

      const message = credit.enabled
        ? 'La sucursal ya no cuenta con créditos activos.'
        : 'Los créditos fueron habilitados correctamente para esta sucursal.';

      notificationService.global.success(message);
    } catch (error) {
      notificationService.global.error(`Error al ${credit.enabled ? 'deshabilitar' : 'habilitar'} los créditos.`);

      return rejectWithValue(error);
    }
  },
);

export const toggleBranchCreditReducer: TSliceExtraReducer<IDistributorsState> = builder =>
  builder
    .addCase(toggleBranchCredit.pending, state => {
      state.branchesList.form.loading = true;
      state.branchesList.form.success = false;
      state.branchesList.form.errors = {};
    })
    .addCase(toggleBranchCredit.rejected, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = false;
    })
    .addCase(toggleBranchCredit.fulfilled, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = true;
      state.branchesList.form.errors = {};
    });
